import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './checklistRespostaForm';
import NovoForm from './checklistRespostaNovoForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import Calendario from '../common/calendario/calendario';

import { setModoTela, initForm, excluir, alterarAgendamento, getLista, getListaRealizado, iniciarChecklist, continuarChecklist, getListaCliente, getListaUsuario, getListaGrupo } from './checklistRespostaActions';
import DateFormat from '../common/dateFormat/DateFormat';
import Select from '../common/form/select';

class ChecklistResposta extends Component {

	state = {
		linhaSelecionada: null,
		paginacaoIndice: 0,
		modoTela: 'calendario',
		ids_checklist: [],
		ids_cliente: [],
		ids_usuario: [],
		ids_grupo: []
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaRealizado();
		this.props.getListaCliente();
		this.props.getListaUsuario();
		this.props.getListaGrupo();

		const idInterval = setInterval(() => {
			this.props.getLista();
			this.props.getListaRealizado();
		}, 40000);

		this.setState({
			...this.state,
			idInterval: idInterval
		});
    }

	componentWillUnmount() {

		if (this.state.idInterval) {
			clearInterval(this.state.idInterval);
		}
	
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'alteracao' ? (
						<NovoForm alteracao agendamento onSubmit={this.props.alterarAgendamento} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<NovoForm excluir agendamento onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
					{this.props.modoTela == 'novoChecklist' ? (
						<NovoForm />
					) : null}
					{this.props.modoTela == 'agendarChecklist' ? (
						<NovoForm agendamento />
					) : null}
                </Content>
            </div>
        )
    }

	lista() {

		const listaRealizado = this.props.listaRealizado.filter(item => {
			//Não listar concluídos ou finalizados
			if (item.id_status == 4) {
				return false;
			}

			if ((this.state.ids_checklist || []).length && !(this.state.ids_checklist || []).includes(item.id_checklist)) {
				return false;
			}
			if ((this.state.ids_cliente || []).length && !(this.state.ids_cliente || []).includes(item.id_cliente)) {
				return false;
			}
			if ((this.state.ids_usuario || []).length && !(this.state.ids_usuario || []).includes(item.id_usuario)) {
				return false;
			}
			if ((this.state.ids_grupo || []).length && !(this.state.ids_grupo || []).includes(item.id_grupo)) {
				return false;
			}

			return true;
		});

		const acessoInterno = this.props.usuarioCarregado && !this.props.usuarioCarregado.acesso_cliente;

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row style={{ alignItems: 'end' }}>
						<Grid cols='6 6 4 2' maxWidth={170}>
							<Button
								text='Iniciar Checklist'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('novoChecklist', {});
									this.props.initForm({
										id_cliente: this.props.usuarioCarregado ? this.props.usuarioCarregado.id_cliente : null
									});
								}} />
						</Grid>
						{acessoInterno &&
						<Grid cols='6 6 4 2' maxWidth={170}>
							<Button
								text='Agendar Checklist'
								type={'warning'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('agendarChecklist', {});
									this.props.initForm({
										data_agendamento: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
									});
								}} />
						</Grid>}
						<button type='button' class='btn btn-primary btn-flat'
							style={{ height: 40 }}
							onClick={() => this.setState({ ...this.state, modoTela: this.state.modoTela == 'lista' ? 'calendario' : 'lista' })}>
							<i class={this.state.modoTela == 'lista' ? 'fas fa-calendar-alt' : 'fas fa-th-list'}></i>
						</button>

						{acessoInterno &&
						<Select
							options={this.props.listaGrupo}
							label='Região / Grupo'
							cols='12 12 6 2'
							placeholder='Selecione'
							marginBottomFormGroup={0}
							value={this.state.ids_grupo}
							multiple
							onChange={values => {
								this.setState({
									...this.state,
									ids_grupo: values.map(item => item.value)
								});
							}} />}

						{acessoInterno &&
						<Select
							options={this.props.listaCliente.filter(item => !(this.state.ids_grupo || []).length || (this.state.ids_grupo || []).includes(item.id_grupo))}
							label='Cliente'
							cols='12 12 6 2'
							placeholder='Selecione'
							marginBottomFormGroup={0}
							value={this.state.ids_cliente}
							multiple
							onChange={values => {
								this.setState({
									...this.state,
									ids_cliente: values.map(item => item.value)
								});
							}} />}

						{acessoInterno &&
						<Select
							options={this.props.listaUsuario.map(item => ({ id: item.id, valor: item.nome }))}
							label='Aplicador'
							cols='12 12 6 2'
							placeholder='Selecione'
							marginBottomFormGroup={0}
							value={this.state.ids_usuario}
							multiple
							onChange={values => {
								this.setState({
									...this.state,
									ids_usuario: values.map(item => item.value)
								});
							}} />}

						<Select
							options={this.props.listaChecklist.map(item => ({ id: item.id, valor: item.nome }))}
							label='Checklist'
							cols='12 12 6 2'
							placeholder='Selecione'
							marginBottomFormGroup={0}
							value={this.state.ids_checklist}
							multiple
							onChange={values => {
								this.setState({
									...this.state,
									ids_checklist: values.map(item => item.value)
								});
							}} />
					
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					{this.state.modoTela == 'lista' &&
					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter>Status</Th>
								<Th alignCenter>Data</Th>
								<Th alignCenter>Checklist</Th>
								<Th alignCenter>Cliente</Th>
								<Th alignCenter>Aplicador</Th>
								<Th alignCenter>Observação</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{listaRealizado.map(item => {

								const checklist = this.props.lista.filter(check => check.id == item.id_checklist)[0] || {};

								return (
									<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
										onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
										onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
										<Td alignCenter>{item.nome_status}</Td>
										<Td alignCenter>{item.id_status == 1 && item.data_agendamento ? `${DateFormat.formatarDataSqlParaTela(item.data_agendamento)}${item.data_agendamento_fim ? ` - ${DateFormat.formatarDataSqlParaTela(item.data_agendamento_fim)}` : ''}` : DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao)}</Td>
										<Td alignCenter>{checklist.nome}</Td>
										<Td alignCenter>{item.nome_cliente}</Td>
										<Td alignCenter>{item.nome_usuario}</Td>
										<Td alignCenter>{item.observacao}</Td>
										<Td alignRight minWidth={10}>																			
											<ButtonTable
												type={'primary'}
												icon={'fas fa-play'}
												visible={this.state.linhaSelecionada == item.id}
												disabled={!item.configuracao_reabrir && item.id_status != 1 && item.id_status == 2 && item.id_status == 3}
												event={() => {
													this.props.continuarChecklist(
														{ ...item, id_status: item.id_status == 1 ? 2 : item.id_status }, 
														(checklistResposta) => {
															this.props.initForm({ ...checklistResposta });
															this.props.setModoTela('cadastro', { ...checklistResposta });
														}
													);
												}} />
											
											<ButtonTable
												type={'warning'}
												icon={'fas fa-pencil-alt'}
												visible={this.state.linhaSelecionada == item.id}
												disabled={item.id_status != 1}
												event={() => {
													this.props.setModoTela('alteracao', {
														...item,
														data_agendamento: DateFormat.formatarDataSqlParaTela(item.data_agendamento),
														data_agendamento_fim: DateFormat.formatarDataSqlParaTela(item.data_agendamento_fim)
													});
													this.props.initForm({
														...item,
														data_agendamento: DateFormat.formatarDataSqlParaTela(item.data_agendamento),
														data_agendamento_fim: DateFormat.formatarDataSqlParaTela(item.data_agendamento_fim)
													});
												}} />

											<ButtonTable
												type={'danger'}
												icon={'fas fa-trash-alt'}
												visible={this.state.linhaSelecionada == item.id}
												disabled={item.id_status == 4}
												event={() => {
													this.props.setModoTela('exclusao', {
														...item,
														data_agendamento: DateFormat.formatarDataSqlParaTela(item.data_agendamento),
														data_agendamento_fim: DateFormat.formatarDataSqlParaTela(item.data_agendamento_fim)
													});
													this.props.initForm({
														...item,
														data_agendamento: DateFormat.formatarDataSqlParaTela(item.data_agendamento),
														data_agendamento_fim: DateFormat.formatarDataSqlParaTela(item.data_agendamento_fim)
													});
												}} />
										</Td>
									</Tr>
								);
							})}
						</TBody>
					</Table>}

					{this.state.modoTela == 'calendario' &&
					<Calendario
						atualizarLista={data => this.props.getLista(data)}
						dados={listaRealizado.map(item => {

							const checklist = this.props.lista.filter(check => check.id == item.id_checklist)[0];

							return {
								id: item.id,
								data: item.id_status == 1 && item.data_agendamento ? item.data_agendamento : item.datahora_inclusao,
								horas: null,
								titulo: ''
									+ `bold${item.nome_status}\n\n`
									+ `${item.nome_cliente}\n\n`
									+ `${checklist ? checklist.nome : ''}\n`
									+ `${item.nome_usuario}\n\n`,
								descricao:
									<div>

									</div>,
								evento: () => {
									this.props.continuarChecklist(
										{ ...item, id_status: item.id_status == 1 ? 2 : item.id_status }, 
										(checklistResposta) => {
											this.props.initForm({ ...checklistResposta });
											this.props.setModoTela('cadastro', { ...checklistResposta });
										}
									);
								},
								id_grupo: 1,
								diaTodo: false,
								corFundo: '#f57215',
								corFonte: '#ffffff'
							}
						})}
						grupos={[{ id: 1, nome: '' }]}
					/>}
				</ContentCardBody>
			</ContentCard>
		);
	}

	novoChecklist() {

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Voltar'
								type={'warning'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('lista', {});
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive>
						<THead>
							<Tr>
								<Th>Data/Hora</Th>
								<Th width={200}></Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.lista.map(item => {

								return (
									<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
										onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
										onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
										<Td>{item.nome}</Td>
										<Td alignRight minWidth={10}>																			
											<Button
												text='Iniciar Checklist'
												type={'success'}
												icon={'fa fa-plus'}
												event={() => {
													this.props.iniciarChecklist(
														{ ...item, id_status: 2 }, 
														(checklistResposta) =>  {
															this.props.initForm({ ...checklistResposta });
															this.props.setModoTela('cadastro', { ...checklistResposta });
														}
													);
												}} />
										</Td>
									</Tr>
								);
							})}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	modoTela: state.checklistResposta.modoTela,
	aguardando: state.checklistResposta.aguardando,
	lista: state.checklistResposta.lista,
	listaRealizado: state.checklistResposta.listaRealizado,
	listaGrupo: state.checklistResposta.listaGrupo,
	listaUsuario: state.checklistResposta.listaUsuario.filter(item => 
		state.auth.usuarioCarregado 
		&& (item.departamentos || []).filter(departamento => (state.auth.usuarioCarregado.departamentos || []).includes(departamento)).length
	),
	listaChecklist: state.checklistResposta.lista,
	listaCliente: state.checklistResposta.listaCliente
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, excluir, alterarAgendamento, getLista, getListaRealizado, iniciarChecklist, continuarChecklist, getListaCliente, getListaUsuario, getListaGrupo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ChecklistResposta);